import { useTranslation } from 'react-i18next';

/**
 * Marks a product the DMC never distributed to this tour operator, so the TO can
 * spot in the diary what the modal announced when it opened.
 *
 * Screen only: the `export-hidden` class is removed from the document by
 * PRINT_STYLES, so the marker never reaches the PDF — the traveller has no
 * business reading about the agency's distribution issues. It also keeps the
 * page-break measurements honest, since the printed layout stays byte-identical
 * to what it was without the badge.
 *
 * Its sentence is longer than the narrow columns it sits in: the parent row
 * wraps it under the product name, and the text itself may break.
 */
export default function ExportInaccessibleBadge({ className = '' }) {
  const { t } = useTranslation('tripDesigner');

  return (
    <span
      className={`export-hidden inline-flex min-w-0 max-w-full items-center gap-1.5 self-center rounded-2xl bg-amber-100 px-2.5 py-0.5 text-sm font-medium text-amber-800 ${className}`}
    >
      <i className="fa-regular fa-triangle-exclamation" />
      {t('productAccess.exportBadge')}
    </span>
  );
}
